import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import * as actions from '../../store/actions/actions'
import UserHeader from "../../components/Headers/UserHeader";
import {Button, Card, CardBody, CardHeader, Col, Container, FormGroup, Input, Row} from "reactstrap";
import {FormControl} from "react-bootstrap";
import "./profile.css"
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";
import italianProfileTranslations from "../../translations/profile/it.profile.json";
import englishProfileTranslations from "../../translations/profile/en.profile.json";
import Modal from "react-bootstrap/Modal";

class Profile extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      updateShow: false
    }

    this.props.addTranslationForLanguage(italianProfileTranslations, "it");
    this.props.addTranslationForLanguage(englishProfileTranslations, "en");
  }

  handleUpdateShow = () => {
    this.props.otpNotificationSend()
    this.setState({
      updateShow: true
    })
  }

  handleUpdateClose = () => {
    this.setState({
      updateShow: false
    })
  }

  handleUpdateProfile = () => {
    this.setState({
      updateShow: false
    })
    this.props.updateProfile(this.props.profile)
  }

  componentDidMount() {
    this.props.fetchCorporates()
    this.props.fetchRoles()
    this.props.fetchBanks()
    this.props.newPasswordClean()
    this.props.newPasswordConfirmClean()
  }

  onBackClick = () => {
    this.props.history.goBack();
  }

  submitHandler = (event) => {
    event.preventDefault();
    this.props.setActiveLanguage(this.props.profile.language)
    this.props.updateProfile(this.props.profile)
  }

  onProfilePictureUpload = async (event) => {
    let image = event.target.files[0]
    event.preventDefault();
    let toBase64 = file => new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
    this.props.profilePictureUpload(await toBase64(image))
  }

  render() {
    // this.state={passwordChange : false}
    let errors="";
    errors=this.props.validationError;
    let nameError = ""
    let userNameError=""
    let emailError=""
    let newPasswordError=""
    let newPasswordConfirmError=""
    let roleError = "";
    let phoneError = "";
    if(errors !== null){
      if(errors.length>0){
        errors.map((item) =>{
          if(item.field === 'fullName')
            nameError=item.defaultMessage;
          if(item.field === 'username')
            userNameError=item.defaultMessage;
          if(item.field === 'email')
            emailError=item.defaultMessage;
          if(item.field === 'newPassword')
            newPasswordError=item.defaultMessage;
          if(item.field === 'newPasswordConfirm')
            newPasswordConfirmError=item.defaultMessage;
          if(item.field === 'role')
            roleError=item.defaultMessage;
          if(item.field === 'phone')
            phoneError=item.defaultMessage;
          return ""
        });
      }
    }

    let updateModal = <Modal show={this.state.updateShow} onHide={this.handleUpdateClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          <Translate id="user.modal.profile.update.title"/>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Translate id="modal.profile.update.body"/>
        <div>
          <input className={"form-control-alternative"} type="password" id="otp" onChange={this.onOtpChange} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={this.handleUpdateClose}>
          <Translate id="update.close"/>
        </Button>
        <Button variant="primary" onClick={this.handleUpdateProfile}>
          <Translate id="update.update"/>
        </Button>
      </Modal.Footer>
    </Modal>

    return (

        <>
          <UserHeader />
          <Container className="mt--7" fluid>
            <Row>
              <Col className="order-xl-2 mb-5 mb-xl-0" xl="4">
                <Card className="card-profile shadow">
                  <Row className="justify-content-center">
                    <Col className="order-lg-2" lg="3">
                      <div className="card-profile-image">
                        <img
                            alt="..."
                            className="rounded-circle"
                            src={
                              this.props.imageString !== '' && this.props.imageString !== null ? this.props.imageString :
                                  require("../../assets/img/theme/defaultprofile.png")
                            }
                        />
                      </div>
                    </Col>
                  </Row>
                  <CardHeader className="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                    <div className="d-flex justify-content-between">
                    </div>
                  </CardHeader>
                  <CardBody className="pt-0 pt-md-4">
                    <Row>
                      <div className="col">
                        <div className="card-profile-stats d-flex justify-content-center mt-md-5">
                          {/*  This section is for some stats about the user*/}
                        </div>
                      </div>
                    </Row>
                    <div className="text-center">
                      <h3>
                        {this.props.fullName}
                      </h3>
                      <div className="h5 font-weight-300">
                        <i className="ni location_pin mr-2" />
                        {this.props.email}
                      </div>
                      <div className="h5 mt-4">
                        <i className="ni business_briefcase-24 mr-2" />
                        {this.props.role}
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col className="order-xl-1" xl="8">
                <Card className="bg-secondary shadow">
                  <CardHeader className="bg-white border-0">
                    <Row className="align-items-center">
                      <Col xs="8">
                        <h3 className="mb-0">
                          <Translate id="profile.account" />
                        </h3>
                      </Col>
                    </Row>
                  </CardHeader>
                  <CardBody>
                    <h6 className="heading-small text-muted mb-4">
                      <Translate id="profile.user.information" />
                    </h6>
                    <div className="pl-lg-4">
                      <form onSubmit={this.submitHandler} autoComplete={"off"}>
                        <input type="hidden" value="nothing"/>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="fullName">
                                <Translate id="profile.user.fullName" />
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                  className={nameError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                  value={this.props.fullName}
                                  onChange={this.onFullNameChange}
                                  autoComplete="off"
                                  id="fullName"
                                  placeholder={translate("profile.user.fullName")}
                                  type="text" />}
                              </Translate>
                              { nameError.length > 0 ? <label style={{color:"red"}}><Translate id={nameError}/></label> : "" }
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="username">
                                <Translate id="profile.user.username" />
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                      disabled
                                      className={userNameError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                      value={this.props.username}
                                      onChange={this.onUsernameChange}
                                      autoComplete="off"
                                      id="username"
                                      placeholder={translate("profile.user.username")}
                                      type="text" />}
                              </Translate>
                              { userNameError.length > 0 ? <label style={{color:"red"}}><Translate id={userNameError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="phone">
                                <Translate id="profile.user.phone" />
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                  className="form-control-alternative"
                                  value={this.props.phone}
                                  onChange={this.onPhoneChange}
                                  autoComplete="false"
                                  disabled
                                  id="phone"
                                  placeholder={translate("profile.user.phone")}
                                  type="text"/>}
                              </Translate>
                              { phoneError.length > 0 ? <label style={{color:"red"}}><Translate id={phoneError}/></label> : "" }
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="language">
                                <Translate id="profile.user.language"/>
                              </label>
                              <Translate>
                                {({ translate }) =>
                                    <FormControl as="select"
                                                 onChange={(newValue) => {
                                                   this.props.onLanguagePreferenceChange(newValue.target.value);
                                                 }}>
                                      <option></option>
                                      {this.props.languages.map((item)=>{
                                        if(item.code=== this.props.language){
                                          return <option value={item.code} selected="selected">{translate(item.code)}</option>
                                        }else{
                                          return <option value={item.code}>{translate(item.code)}</option>
                                        }
                                      })}
                                    </FormControl>}
                              </Translate>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="email">
                                <Translate id="profile.user.email" />
                              </label>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                  className={emailError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                  value={this.props.email}
                                  disabled
                                  onChange={this.onEmailChange}
                                  autoComplete="off"
                                  id="email"
                                  placeholder={translate("profile.user.email")}
                                  type="text"/>}
                            </Translate>
                              { emailError.length > 0 ? <label style={{color:"red"}}><Translate id={emailError}/></label> : "" }
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="role">
                                <Translate id="profile.user.role" />
                              </label>
                              <FormControl className={roleError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                           as="select"
                                           disabled
                                           onChange={(newValue) => {
                                this.onRoleChange(newValue.target.value);
                              }}>
                                <option></option>
                                {this.props.roles.map((item)=>{
                                  if(item.value === this.props.role){
                                    return <option value={item.value} selected="selected">{item.value}</option>
                                  }else{
                                    return <option value={item.value}>{item.value}</option>
                                  }

                                })}
                              </FormControl>
                              { roleError.length > 0 ? <label style={{color:"red"}}>{roleError}</label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="bank">
                                <Translate id="profile.user.bank" />
                              </label>
                              <FormControl as="select"
                                           disabled
                                           onChange={(newValue) => {
                                             this.onIdBankChange(newValue.target.value);
                                           }}>
                                <option></option>
                                {this.props.banks.map((item)=>{
                                  if(item.bankId=== this.props.idBank){
                                    return <option value={item.bankId} selected="selected" >{item.bankName}</option>
                                  }else{
                                    return <option value={item.bankId} >{item.bankName}</option>
                                  }
                                })}
                              </FormControl>
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="corporate">
                                <Translate id="profile.user.corporate" />
                              </label>
                              <FormControl as="select"
                                           disabled
                                           onChange={(newValue) => {
                                             this.onCorporateSenderIdChange(newValue.target.value);
                                           }}
                              >
                                <option></option>
                                {this.props.corporates.map((item)=>{
                                  if(item.corporateSenderId===this.props.corporateSenderId){
                                    return <option value={item.corporateSenderId} selected="selected">{item.corporateSenderName}</option>
                                  }else{
                                    return <option value={item.corporateSenderId}>{item.corporateSenderName}</option>
                                  }
                                })}
                              </FormControl>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="newPassword">
                                <Translate id="profile.user.newPassword" />
                              </label>
                              <Translate>
                                {({ translate }) =>
                                    <Input
                                        className={newPasswordError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                        value={this.props.newPassword}
                                        id="newPassword"
                                        type="password"
                                        autoComplete="off"
                                        onChange={this.onNewPasswordChange}
                                        placeholder={translate("profile.user.newPassword")}
                                        />}
                              </Translate>
                              { newPasswordError.length > 0 ? <label style={{color:"red"}}><Translate id={newPasswordError}/></label> : "" }
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label" htmlFor="newPasswordConfirm">
                                <Translate id="profile.user.newPasswordConfirm" />
                              </label>
                              <Translate>
                                {({ translate }) =>
                                    <Input
                                        className={newPasswordConfirmError.length > 0 ? 'form-control-alternative validationError' : 'form-control-alternative' }
                                        value={this.props.newPasswordConfirm}
                                        id="newPasswordConfirm"
                                        type="password"
                                        autoComplete="off"
                                        onChange={this.onNewPasswordConfirmChange}
                                        placeholder={translate("profile.user.newPasswordConfirm")}
                                         />}
                              </Translate>
                              { newPasswordConfirmError.length > 0 ? <label style={{color:"red"}}><Translate id={newPasswordConfirmError}/></label> : "" }
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <Col><label className="form-control-label" htmlFor="files" >
                                <Translate id="profile.user.logo" />
                              </label>
                              </Col>
                              <Col>
                                <label className="btn btn-default">
                                  <Translate>
                                    {({ translate }) =>
                                        <Input
                                            className="button form-control-alternative"
                                            onChange={this.onProfilePictureUpload}
                                            id="files"
                                            placeholder={translate("profile.user.logo")}
                                            type="file"
                                            />}
                                  </Translate>
                                </label>

                              </Col>
                            </FormGroup>
                          </Col>
                        </Row>
                        <hr className="my-4" />
                          <h6 className="heading-small text-muted mb-4">
                            <Translate id="profile.user.description" />
                          </h6>
                          <div className="pl-lg-4">
                            <FormGroup>
                              <Translate>
                                {({ translate }) =>
                                  <Input
                                  className="form-control-alternative"
                                  rows="4"
                                  value={this.props.description}
                                  onChange={this.onDescriptionChange}
                                  type="textarea"/>}
                              </Translate>
                            </FormGroup>
                          </div>
                        <Row>
                          <Button onClick={this.handleUpdateShow}>
                            <Translate id="profile.user.update.button" />
                          </Button>
                        </Row>
                      </form>
                      {updateModal}
                    </div>
                    <hr className="my-4" />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
    );
  }

  onRoleChange = (role) => {
    this.props.roleChange(role)
  }


  onIdBankChange = (idBank) => {
    if(idBank !== 'undefined')
      this.props.idBankChange(idBank)
  }

  onCorporateSenderIdChange = (corporateSenderId) => {
    if(corporateSenderId !== 'undefined')
      this.props.corporateSenderIdChange(corporateSenderId)
  }

  onEnabledChange = (event) => {
    let enabled = event.target.value === "true" ? true : false
    this.props.enabledChange(enabled)
  }

  onFullNameChange = (event) => {
    let fullName = event.target.value
    this.props.fullNameChange(fullName)
  }

  onDescriptionChange = (event) => {
    let description = event.target.value
    this.props.descriptionChange(description)
  }

  onUsernameChange = (event) => {
    let username = event.target.value
    this.props.usernameChange(username)
  }

  onNewPasswordChange = (event) => {
    let newPassword = event.target.value
    this.props.newPasswordChange(newPassword)
  }

  onNewPasswordConfirmChange = (event) => {
    let newPasswordConfirm = event.target.value
    this.props.newPasswordConfirmChange(newPasswordConfirm)
  }

  onPhoneChange = (event) => {
    let phone = event.target.value
    this.props.phoneChange(phone)
  }

  onEmailChange = (event) => {
    let email = event.target.value
    this.props.emailChange(email)
  }

  onResetChange = (event) => {
    let reset = event.target.value === "true" ? true : false
    this.props.resetChange(reset)
  }

  onOtpChange = (event) => {
    let otp = event.target.value
    this.props.otpChange(otp)
  }

  enabledPasswordChange=()=>{
    let username = this.props.username
    let email = this.props.email
    let password = this.props.password
    let data = {"username": username, "email": email, "password": password}
    this.props.resetUserPassword(data)
    this.handlePasswordClose()
  }
}

const mapStateToProps = state => {
  return {
    profile: state.profile.profile,
    idBank: state.profile.profile.idBank,
    corporateSenderId: state.profile.profile.corporateSenderId,
    fullName: state.profile.profile.fullName,
    description: state.profile.profile.description,
    enabled: state.profile.profile.enabled === true ? "true" : "false",
    username: state.profile.profile.username,
    phone: state.profile.profile.phone,
    email: state.profile.profile.email,
    reset: state.profile.profile.reset === true ? "true" : "false",
    role: state.profile.profile.role,
    imageString:state.profile.profile.imageString,
    roles: state.role.roles,
    banks: state.bank.banks,
    corporates: state.corporate.corporates,
    validationError:state.profile.error,
    languages: state.localize.languages,
    language: state.profile.profile.language,
    otp: state.profile.profile.otp,
    newPassword: state.profile.profile.newPassword,
    newPasswordConfirm: state.profile.profile.newPasswordConfirm
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateProfile: (profile) => dispatch({ type: actions.UPDATE_PROFILE_EDIT_REQUEST, value: profile }),
    idBankChange: (idBank) => dispatch({ type: actions.EDIT_PROFILE_ID_BANK_FIELD_CHANGE_REQUEST, value: idBank }),
    corporateSenderIdChange: (corporateSenderId) => dispatch({ type: actions.EDIT_PROFILE_CORPORATE_SENDER_ID_FIELD_CHANGE_REQUEST, value: corporateSenderId }),
    fullNameChange: (fullName) => dispatch({ type: actions.EDIT_PROFILE_FULL_NAME_FIELD_CHANGE_REQUEST, value: fullName }),
    descriptionChange: (description) => dispatch({ type: actions.EDIT_PROFILE_DESCRIPTION_FIELD_CHANGE_REQUEST, value: description }),
    enabledChange: (enabled) => dispatch({ type: actions.EDIT_PROFILE_ENABLED_FIELD_CHANGE_REQUEST, value: enabled }),
    usernameChange: (username) => dispatch({ type: actions.EDIT_PROFILE_PROFILE_NAME_FIELD_CHANGE_REQUEST, value: username }),
    newPasswordChange: (newPassword) => dispatch({ type: actions.EDIT_PROFILE_NEW_PASSWORD_FIELD_CHANGE_REQUEST, value: newPassword }),
    newPasswordConfirmChange: (newPasswordConfirm) => dispatch({ type: actions.EDIT_PROFILE_NEW_PASSWORD_CONFIRM_FIELD_CHANGE_REQUEST, value: newPasswordConfirm }),
    phoneChange: (phone) => dispatch({ type: actions.EDIT_PROFILE_PHONE_FIELD_CHANGE_REQUEST, value: phone }),
    emailChange: (email) => dispatch({ type: actions.EDIT_PROFILE_EMAIL_FIELD_CHANGE_REQUEST, value: email }),
    resetChange: (reset) => dispatch({ type: actions.EDIT_PROFILE_RESET_FIELD_CHANGE_REQUEST, value: reset }),
    roleChange: (role) => dispatch({ type: actions.EDIT_PROFILE_ROLE_FIELD_CHANGE_REQUEST, value: role }),
    fetchRoles: () => dispatch({ type: actions.FETCH_ROLES_REQUEST }),
    fetchBanks: () => dispatch({ type: actions.FETCH_BANKS_REQUEST }),
    fetchCorporates: () => dispatch({ type: actions.FETCH_CORPORATES_REQUEST }),
    profilePictureUpload: (profilePicture) => dispatch({ type: actions.EDIT_USER_PICTURE_UPLOAD_REQUEST, value: profilePicture }),
    onLanguagePreferenceChange: (language) => dispatch({ type: actions.EDIT_PROFILE_LANGUAGE_FIELD_CHANGE_REQUEST, value: language }),
    otpChange: (otp) => dispatch({ type: actions.EDIT_PROFILE_OTP_CHANGE_REQUEST, value: otp }),
    newPasswordClean: () => dispatch({ type: actions.EDIT_PROFILE_NEW_PASSWORD_FIELD_CLEAN_REQUEST }),
    newPasswordConfirmClean: () => dispatch({ type: actions.EDIT_PROFILE_NEW_PASSWORD_CONFIRM_FIELD_CLEAN_REQUEST }),
    otpNotificationSend: () => dispatch({ type: actions.EDIT_PROFILE_OTP_NOTIFICATION_SEND_REQUEST })
  }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(Profile));